export default __webpack_public_path__ + "static/media/revealed5.69c93f9e.png";